<template>
  <div class="user-info">
    <div>
      <iain-image-domain w="90" h="90" r="6" :src="avatar" />
    </div>
    <div class="user-info-name">{{ name }}</div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    avatar: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.user-info {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 150px;

  .user-info-name {
    padding-top: 20px;
    width: 138px;
    font-size: 24px;
    color: #666666;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
